import React from 'react';
import agent from '../../agent';
import defaultAvatar from '../../images/avatar.svg';
import anonymousAvatar from '../../images/avatar.svg';

class PostAvatar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      image: defaultAvatar,
      isFetched: false,
    }
  }

  componentWillMount() {
    if (this.props.userName) {
      this.fetchAvatar(this, this.props.userName)
    }
  }

  fetchAvatar = (that, userName) => {
    if (!this.state.isFetched && userName) {
      agent.User.fetchUserAvatar(userName).then(res => {
        var reader = new window.FileReader();
        reader.readAsDataURL(res.xhr.response);
        reader.onloadend = () => {
          that.setState({
            image: reader.result,
            isFetched: false,
          })
        }
      }).catch(err => {
        that.setState({
          image: defaultAvatar,
          isFetched: false,
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.userName !== nextProps.userName && nextProps.userName) || (this.props.isAvatar !== nextProps.isAvatar)) {
      this.fetchAvatar(this, nextProps.userName)
    }
  }

  render() {
    return (
      <img src={this.props.isAnonymous ? anonymousAvatar :this.state.image} ref="myImg" alt={this.props.userName} width={this.props.height ? this.props.height : "50"} height={this.props.width ? this.props.width : "50"} className={`${this.props.className ? this.props.className : 'img-circle border-radius-10'}`} />
    );
  }
}

export default PostAvatar;
